<label [attr.for]="fieldId">
  <span class="label">{{ text(question.title) }}</span>
  <span class="required-indicator" *ngIf="question.required">* {{ requiredIndicator }}</span>
  <span class="description" *ngIf="question.description">{{ text(question.description) }}</span>
</label>

<mat-radio-group
  class="rating"
  *ngIf="question.type === 'nps'"
  [name]="fieldId"
  [formControl]="control"
  (change)="onAnswerChange(control.value)"
>
  <mat-radio-button *ngFor="let scaleValue of getScaleValues()" [value]="scaleValue">
    {{ scaleValue }}
  </mat-radio-button>
</mat-radio-group>

<app-survey-star-rating
  class="rating-stars"
  *ngIf="question.type === 'star'"
  [readonly]="false"
  [wholeStars]="true"
  [maxStars]="getStarMax()"
  [initialStars]="getStarControlValue()"
  [color]="'#ffcc00'"
  (ratingChange)="onStarRatingChange($event)"
></app-survey-star-rating>

<mat-radio-group
  class="choices"
  *ngIf="question.type === 'choice'"
  [name]="fieldId"
  [formControl]="control"
  (change)="onAnswerChange(control.value)"
>
  <mat-radio-button *ngFor="let option of question.options" [value]="option.value">
    {{ text(option.label) }}
  </mat-radio-button>
</mat-radio-group>

<mat-form-field appearance="outline" class="textarea-field" *ngIf="question.type === 'textarea'">
  <textarea
    matInput
    [id]="fieldId"
    [name]="fieldId"
    [formControl]="control"
    (input)="onAnswerChange(control.value)"
    rows="4"
    [placeholder]="textareaPlaceholder"
  ></textarea>
</mat-form-field>
